import { frontendURL } from '../../../helper/URLHelper';
import KanbanBoard from '../../../../crm/views/KanbanBoard.vue';
import { FEATURE_FLAGS } from '../../../featureFlags';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/crm'),
    name: 'crm_index',
    component: KanbanBoard,
    meta: {
      featureFlag: FEATURE_FLAGS.CRM,
      permissions: ['administrator', 'agent', 'custom_role'],
    },
  },
];
